'use client';

import clsx from 'clsx';

import { testingProcessSteps } from '@/data/shop/swab-kit/testing-process.data';

export const SwabKitProductDetailsTestingProcess: React.FC = () => {
  return (
    <div className="mb-8">
      <div
        className={clsx(
          'mb-6 font-light',
          'text-xl leading-[30px] tracking-[-.6px]',
          'md:text-xl md:leading-[24px] md:tracking-[-.6px]'
        )}
      >
        Simple & easy testing process at-home
      </div>
      <div className="relative">
        <div
          className={clsx(
            'absolute z-5',
            'top-[11px] left-[11px] bottom-[20%]',
            'md:top-[15px] md:left-[15px] md:bottom-[20%]',
            'w-[2px] bg-badge-gray'
          )}
        />

        {testingProcessSteps.map((testingProcessStep, index) => (
          <div className="mb-6" key={index}>
            <div className="flex justify-start items-start">
              <div
                className={clsx(
                  'shrink-0 bg-white me-4 z-10',
                  'flex justify-center items-center',
                  'border border-1 border-badge-gray',
                  'outline outline-4 outline-white',
                  'w-[24px] h-[24px] rounded-[78px]',
                  'md:w-[32px] md:h-[32px] md:rounded-[78px]',
                  'text-base leading-[19.2px] tracking-[-0.48px]',
                  'md:text-lg md:leading-[21.6px] md:tracking-[-0.54px]'
                )}
              >
                {index + 1}
              </div>
              <div>
                <div
                  className={clsx(
                    'text-base leading-[22.4px] tracking-[-0.48px]',
                    'md:text-lg md:leading-[27px] md:tracking-[-0.54px]'
                  )}
                >
                  {testingProcessStep.title}
                </div>
                <div
                  className={clsx(
                    'font-light',
                    'text-[15px] leading-[22.5px] tracking-[-0.45px]',
                    'md:text-base md:leading-[24px] md:tracking-[-0.48px]'
                  )}
                >
                  {testingProcessStep.description}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
